var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./exportFile.constants";
export var getPaged = (_a = generatePromises(GENERATOR_PARAMS), _a.getPaged), create = _a.create;
